import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  avatar: {
    width: "40px",
    height: "40px",
    borderRadius: "8px",
    fontSize: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "rgba(72,100,148,1)",
  },
  image: {
    borderRadius: "8px",
    width: "100%",
    height: "100%",
    objectFit: "cover",
    boxShadow: "0px 0px 2px 2px rgba(0, 0, 0, 0.04) inset",
  },
}));
